import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {ProjectService} from '../project.service';
import {Client} from 'src/app/model/client';
import {Json2TypescriptUtil} from '../../util/json2TypescriptUtil';
import {GenericModalComponent} from '../../modal/generic-modal.component';
import {Project} from '../../model/project';
import {FormModel} from '../../model/forms/form-model';
import {ClientFormUtil} from '../../model/FormUtil/clientFormUtil';
import {CreateObjectDialogComponent} from '../../createObjectDialog/create-object-dialog.component';
import {Email} from '../../model/email/email';
import {Questionnaire} from '../../model/questionnaire';
import {Terminal} from '../../model/terminal';
import {ContentPreviewPaneComponent} from '../../content-preview-pane/content-preview-pane.component';
import {CreateEmailComponent} from '../email/create-email.component';
import {Node} from '../../model/treeview/node';
import {Leaf} from '../../model/treeview/leaf';
import {SimpleInputComponent} from '../../modal/simple-input.component';
import {StringUtil} from '../../util/stringUtil';
import {TerminalUtil} from '../../util/terminalUtil';
import {SendTestEmailComponent} from '../emailTest/send-test-email.component';

@Component({
    selector: 'emailComposer',
    template: `<div class="modal" [style.display]="!hide ? 'inline' : 'none'" >
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <!-- header-->
                <div class="modal-header">
                    <h4 class="modal-title"><span><img alt="icon" class="appWindow" src="../../../assets/images/outlookIcon.png"></span></h4>
                    <h4>Email Composer</h4>
                    <h4 class="closeBtnH4"><button (click)="toggleDialog();" class="btn btn-outline-danger my-2 my-sm-0 closeBtnDiv" data-dismiss="modal" aria-label="Close">
                        <span class="closeX" aria-hidden="true"><img class="closeIcon" alt="closeBtn" src="../../../assets/images/closeBtn.png"></span>
                    </button></h4>
                </div>
                <div class="modalBodyContainer">
                    <div class="modal-body">
                        <!--<ribbon (newEmail)="onNewEmail()"></ribbon>-->
                        <table>
                            <td>
                                <treeview [node]="node" (changeFileName) = changeFileName($event) (propagateNodeClick)=onNodeSelected($event)></treeview>
                            </td>
                            <td>
                                <div class="container">
                                <table class="table" style="margin-left:-16px">
                                <thead class="tableHeader">
                                <tr>
                                    <th>Email</th>
                                    <th>Created On</th>
                                    <th>Action</th>
                                    <th>Edit</th>
                                    <th>View Template</th>
                                    <th>Send Test Mail</th>
                                    <th>Set Template</th>
                                </tr>
                                </thead>
                                <tbody>
                                    <ng-container *ngFor="let item of emailArr">
                                        <tr *ngIf="item!==null" class="clientRow"  style="border-bottom: 2px solid #444444;align-content: center;">
                                            <td>
                                                <div role="alert" style="font-weight:bold;height: 18px; width:250px;padding-top:1px;font-size: 14px;margin-top:15px;">
                                                    <div><span style="margin-right: 10px;color:#0aa361;float: left;"><img alt="user" style="width: 32px;" src="../../../assets/images/outlookIcon.png"></span></div>
                                                    <div style="text-align: center;float: left;"> <span maxlength="20">{{item.subject.get('en') + item.templateId}}</span></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div role="alert"
                                                     style="text-align:center;font-weight:bold;height: 18px;margin-left:5%; width:150px;padding-top:1px;font-size: 14px;margin-top:15px;">
                                                    <strong>{{item.createdDate}}</strong>
                                                </div>
                                            </td>
                                            <td>
                                                <div role="alert" style="margin-left:5%;text-align:center;font-weight:bold;height: 18px; width:50px;padding-top:1px;font-size: 14px;margin-top:15px;">
                                                    <button class="btn btn-danger btn-xs"
                                                            (click)="removeEmailDefinition(item.templateId);">
                                                        <span class="glyphicon glyphicon-trash"></span> Remove
                                                    </button>
                                                </div>
                                            </td>
                                            <td>
                                                <div role="alert" style="margin-left:20%;text-align:center;font-weight:bold;height: 18px; width:fit-content;padding-top:1px;font-size: 14px;margin-top:15px;">
                                                    <button  class="btn btn-warning btn-xs"
                                                            (click)="onUpdate(item.templateId);">
                                                        <span style="color:#ffffff;"><i  style="font-size: large" class="far fa-edit"></i></span>
                                                    </button>
                                                </div>
                                            </td>
                                            <td>
                                                <div role="alert" style="margin-left:5%;text-align:center;font-weight:bold;height: 18px; width:150px;padding-top:1px;font-size: 14px;margin-top:15px;">
                                                    <button class="btn btn-success btn-xs"
                                                            (click)="generateTemplatePreview(item.templateId);">
                                                        Load Template
                                                    </button>
                                                </div>
                                            </td>

                                            <td>
                                                <div role="alert" style="margin-left:5%;text-align:center;font-weight:bold;height: 18px; width:150px;padding-top:1px;font-size: 14px;margin-top:15px;">
                                                    <button type="button" class="btn btn-primary btn-xs" style="margin-right: 10px;"
                                                            (click)="onEmailSendClick(item.templateId)" data-toggle="tooltip" data-placement="top" title="Test Send Email"><span><i
                                                            class="fas fa-at"></i></span></button>
                                                </div>
                                            </td>
                                          <td>
                                            <div role="alert" style="margin-left:5%;text-align:center;font-weight:bold;height: 18px; width:150px;padding-top:1px;font-size: 14px;margin-top:15px;">
                                              <input type="radio"  style="margin-right: 10px;"
                                                      [checked] = evaluate(item.templateId,terminal.selectedEmailTemplate)
                                                      (click)="setEmailTemplateForTerminal(item.templateId)" data-toggle="tooltip" data-placement="top" title="Set Email Template For Terminal"/>
                                            </div>
                                          </td>
                                        </tr>
                                    </ng-container>
                                </tbody>
                            </table>
                                </div>
                            </td>
                            <td>
                                <previewPane (alert)="generateAlert($event)" [path]="_path" [isEmail]="true" [langArr]="this.questionnaire.languages" [pId]="project.id" [qId]="questionnaire.id" [tId]="terminal.id" [terminalType]="this.terminal.type"></previewPane>
                            </td>
                        </table>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary clickable hand" (click)="showAddClient()" >New Client</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <generic-info-modal (OkClick)="onOk()"></generic-info-modal>
    <create-object-dialog (NewObjectEvent)="onNewEvent($event)" [modelObject]="intentModel" [formModel]="formModel" [wizardTitle]="formModel.title"></create-object-dialog>
    <create-email-dialog  (NewEmailCreate)="onEmailCreate($event)" (CancelCreateEmail)="hideCreateEmailDialog()" [project]="project" [questionnaire]="questionnaire" [terminal]="terminal" [email]="selectedEmail" [flag]="flag"></create-email-dialog>
    <simpleInput></simpleInput>
    <send-test-email-dialog  [langArr]="this.questionnaire.languages" [terminal]="this.terminal" [questionnaire]="this.questionnaire" [path]="_path" ></send-test-email-dialog>
    `
    ,
    styles:[`
        .container {
            margin: 50px auto 0;
            height: 1200px;
            background: #f5f5f5;
            padding: 30px;
            border-radius: 5px;
            border: solid 2px #777;
            box-shadow: 0 0 5px #333;
        }
        .modal-title{margin-top: -5px;}
        .closeBtnH4{margin-top:-5px;margin-right: -8px;}
        .appWindow {
            height: 35px;
        }
        .clientRow{background-color: #D0DFFE;}

        .tableHeader{ background-image: url("../../../assets/images/blueBack.jpg");}
        th{color:#ffffff;text-align: center;}

        .modalBodyContainer{
            background-color: #ECE8E5;
        }

        .modal-footer{background-color: #ECE8E5;}
        .modal-body {
            width: 100%;
            overflow-y: auto;
            height: 700px;
        }
        .modal-body thead {
            position: sticky;
            top:0;
        }
        ::-webkit-scrollbar {
            width: 14px;
            height: 5px;
            background-color: #F5F3F0;
        }
        ::-webkit-scrollbar-thumb {
            height: 6px;
            border: 4px solid rgba(0, 0, 0, 0);
            background-clip: padding-box;
            -webkit-border-radius: 7px;
            background-color:#BACEFF;
            -webkit-box-shadow: inset -1px -1px 0px rgba(0, 0, 0, 0.05), inset 1px 1px 0px rgba(0, 0, 0, 0.05);
        }
        ::-webkit-scrollbar-button {
            width: 14px;
            height: 14px;
            display: none;
        }
        ::-webkit-scrollbar-corner {
            background-color: transparent;
        }

        .modal-dialog {
            max-width: 1900px;
            margin: 50px auto auto;
            background-color: #0064FE;
            border-top-right-radius: 10px;
            border-top-left-radius: 10px;
        }

        .modal-header {
            height:56px;
            //background-color: #0064FE;
            background-image: url("../../../assets/images/headerBack.jpg");
            color: antiquewhite;
            border-top-right-radius: 10px;
            border-top-left-radius: 10px;
        }

        .modal-content {
            border-top-right-radius: 10px;
            border-top-left-radius: 10px;
          padding-bottom: 3px;
          padding-left: 3px;
          padding-right: 3px;
            background-color: #0064FE;
        }

        .closeX {
            color: white;
            size: 25px;
        }

        .btn-outline-danger {
            background-color: #d6462e;
            border-style: solid;
            border-color: white;
            border-width: 2px;
            padding: 0;
        }

       /* .btn-outline-danger:hover {
            width: 32px;
            background-image: url("../../../assets/images/closeBtnHovered.png");
        }*/

        .closeIcon:hover{ width: 32px;background-image: url("../../../assets/images/closeBtnHovered.png");}

        .closeIcon{ width: 32px;background-image: url("../../../assets/images/closeBtn.png");}

        .btn-success {
              background-color: #08780C;

              border-style: solid;
              border-color: white;
              border-width: 2px;
          }

        .modOK{ background-image: url("../../../assets/images/290x24x24.png");background-repeat: no-repeat;}

        .btn-success:hover {
            background-color: #0CAF10;
        }

        .btn-warning {
            background-color: #F1C829;
            border-style: solid;
            border-color: white;
            border-width: 2px;
        }

        .btn-warning:hover {
            background-color: #F7DD77;
        }
    `]
})
export class EmailComposerComponent implements OnInit {

    @Output() error: EventEmitter<any> = new EventEmitter();

    private clients:Client[];

    private flag = 'open';

    private hide = true;

    private editUserId=0;

    private modifiedUserVal='';

    private intentModel:(Project|Client) = new Project();

    private formModel:FormModel;

    private node =  new Node('Templates');

    //
    @Input() project:Project;
    @Input() questionnaire:Questionnaire;

    @Input() terminal:Terminal;

    @Input() terminalTypeId = 0;
    /*@Input() pId = 0;
    @Input() qId = 0;
    @Input() tId = 0;*/

    private selectedEmail:Email;

    private emailArr:Email[] = [];
    private _errorMessage: any;
    private _path='';



    @ViewChild (CreateObjectDialogComponent) private createProjectComponent:CreateObjectDialogComponent;
    @ViewChild (GenericModalComponent) private genericModal:GenericModalComponent;
    @ViewChild (ContentPreviewPaneComponent) private contentPreviewPane:ContentPreviewPaneComponent;
    @ViewChild (CreateEmailComponent) private createEmailComponent: CreateEmailComponent;
    @ViewChild (SimpleInputComponent) private simpleInputComponent: SimpleInputComponent;
    @ViewChild (SendTestEmailComponent) private sendTestMailComponent:SendTestEmailComponent;

    constructor(private _projectService: ProjectService) {
    }

    ngOnInit(): void {
        this.formModel =  ClientFormUtil.generateClientForm();
        console.log('calling get email bucket');
        this.getEmailBucket(this.terminalTypeId);
    }

    private  getEmailBucket(typeId:number) {
        this._projectService.getEmailBucket(this.project.id,this.questionnaire.id,this.terminal.id,typeId).subscribe(async (courier: any) => {

                if (courier != null) {
                    // const t  = Json2TypescriptUtil.getJsonConvertInstance().deserializeObject(courier[0], Email);
                    this.emailArr = Json2TypescriptUtil.getJsonConvertInstance().deserializeArray(courier, Email);
                    /*const r = new Email();s
                    r.templateId = 1;
                    r.subject.set('fr','Francais');
                    r.subject.set('en','English');
                    r.configPath = 'Email/tmpo/Kugan/email.json';
                    this.emailArr.push(r);*/

                    await this.parseConfigPath(); // asynchronously wait

                    console.log('emailBucket array: ' + this.node);
                }
            },
            error => this._errorMessage = <any>error);
    }


    fetchClients() {
        this._projectService.getRegisteredClients()
            .subscribe(data => {
                    console.log(data);
                    this.clients = Json2TypescriptUtil.getJsonConvertInstance().deserializeArray(data,Client);
                },
                error => {console.log('Error registering a device');this.error.emit('An error occurred while fetching clients:'+350+'\n Try again later.');});
    }

    // TODO: Refactorer avec un code recurisive
    async  parseConfigPath() {
        // const node = new Node('Email');
        for(const email of this.emailArr) {
            if(email == null) {
                continue;
            }
            if(email.templateId.length===0) {
                email.templateId = StringUtil.getSerial();
            }
            const strArr = email.configPath.split('/');
            let path='';

            const node = this.node;
            let lastNode:Node = null;
            for(let i =0;i<strArr.length;i++) {

                if(strArr[i].match('\\w*[.]\\w*')) {
                    const leaf= new Leaf(strArr[i]);
                    leaf.setPath(email.configPath);
                    leaf.setTemplateId(email.templateId);
                    lastNode.setLeaf(leaf);
                    path = '';
                } else {
                    /*for(const nod of node.getNodeList()) {
                        if(nod.getName()===str) {
                          lastNode = nod;
                        }
                    }*/
                    //  if(lastNode == null) {
                    let prevNodeValue = '';
                    if(i !== 0) {
                        prevNodeValue = strArr[i-1];
                    }

                        lastNode = this.findTreeNode(node,prevNodeValue,strArr[i]);
                        if(lastNode == null) {
                            lastNode = node;
                        }
                        if(strArr[i]!=='Email') {
                            path += ('/' + strArr[i]);
                        } else {
                            path += (strArr[i]);
                        }
                        if(lastNode.getName()!== strArr[i]) {
                            lastNode = lastNode.setNode(new Node(strArr[i]));
                            lastNode.setPath(path);
                        }
                    //  }
                }
            }
        }
    }

    private  onEmailSendClick(id:string) {
        for(const email of this.emailArr) {
            if(email.templateId === id) {
                this.selectedEmail = email;
                this._path = email.configPath;
            }
        }
        this.sendTestMailComponent.toggle();
    }

    private setEmailTemplateForTerminal(id:string) {
      for(const email of this.emailArr) {
        if(email.templateId === id) {
          this.selectedEmail = email;
          this._path = email.configPath;
        }
      }
      this.terminal.selectedEmailTemplate = id;
      this._projectService.setEmailTemplateForTerminal(this.project.id,this.questionnaire.id,this.terminal.id,this._path,'email').subscribe(()=> {
        this.genericModal.defineModal('Email template has been set!','Terminal Node',200);
        this.genericModal.toggleModal();
      });
    }

    private findTreeNode(node:Node,prevNodeName:string,name:string):Node {
        for(const nod of node.getNodeList()) {
           if(nod.getName() === name) {
               return nod;
           }
        }
        for(const nod of node.getNodeList()) {
            if(nod.getName() === prevNodeName) {
                return nod;
            }
        }
        return null;
    }


    toggleDialog() {
        this.hide = !this.hide;
        console.log(this.hide);
        if(this.hide===false) {
            this.fetchClients();
        }
    }

    private removeEmailDefinition(id:string) {

        this.selectedEmail = new Email();
        for(const email of this.emailArr) {
            if(email.templateId === id) {
                this.selectedEmail = email;
            }
        }
        this._projectService.removeEmailDefinition(this.project.id,this.questionnaire.id,this.terminal.id,TerminalUtil.getTerminalTypeId(this.terminal.type),this.selectedEmail.configPath,this.selectedEmail.templateId).subscribe((msg)=> {

            if(msg === 100) {
                // this.showGenericAlertMsgBox('Email definition has been deleted successfully !','Terminal Node',200);
                this.genericModal.defineModal('Email definition has been deleted successfully !','Terminal Node',200);
                this.emailArr.splice(this.getTemplateIndex(this.selectedEmail.templateId),1);
            } else if(msg === 102) {
                // this.showGenericAlertMsgBox('An error has occurred while removing Email Definition!','Terminal Node',msg);
                this.genericModal.defineModal('An error has occurred while removing Email Definition!','Terminal Node',msg);
            } else if(msg === 204) {
                // this.showGenericAlertMsgBox('An error has occurred while removing Email Definition!','Terminal Node',msg);
                this.genericModal.defineModal('Email definition has been already deleted!','Terminal Node',msg);
            }
            this.genericModal.toggleModal();
        });
    }

    onRemove(id: number) {
        this._projectService.removeRegisteredClient(id).subscribe((val=> {
                if(val === true) {
                    this.genericModal.defineModal('Client was removed Successfully!','Client Manager',100);
                } else {
                    this.genericModal.defineModal('Some error occurred while removing client!','Client Manager',350);
                }
                this.genericModal.toggleModal();
            }),
            error => {console.log('Error while removing client.');this.genericModal.defineModal('Some error occurred while removing client! \n'+error.error +' \n'+ error.status,'Client Manager',350);this.genericModal.toggleModal();});
    }

    generateTemplatePreview(id: string) {
        // this.contentPreviewPane.renderPreview();
        for(const email of this.emailArr) {
            if(email.templateId === id) {
                this.selectedEmail = email;
                this._path = email.configPath;
            }
        }
    }

    private getTemplateIndex(id:any) {
        let idx = 0;
        for(let i =0;i<this.emailArr.length;i++) {
            if(this.emailArr[i].templateId === id) {
            idx = i;
            }
        }
        return idx;
    }

    onUpdate(id: string) {
        this.flag = StringUtil.getSerial();
        this.selectedEmail = new Email();
        for(const email of this.emailArr) {
            if(email.templateId === id) {
                this.selectedEmail = email;
            }
        }
        this.createEmailComponent.show(this.selectedEmail);
    }


    onOk() {
        this.genericModal.toggleModal();
        this.fetchClients();
    }

    public onEmailCreate(email: Email) {
        this._projectService.createEmail(email, this.project.id,this.questionnaire.id,this.terminal.id, this.terminalTypeId).subscribe(
            (msg) => {
                console.log(msg);
                // this.showGenericAlertMsgBox('Email has  been saved successfully !','Mail Creator',200);
                this.genericModal.defineModal('Email has  been saved successfully !','Mail Creator',200);
                this.genericModal.toggleModal();
                this.hideCreateEmailDialog();
            });
    }

    private hideCreateEmailDialog() {
        this.createEmailComponent.hideDialog();
    }

    private showAddClient() {
        this.intentModel = new Client();
        this.formModel = ClientFormUtil.generateClientForm();
        this.createProjectComponent.toggleDialog();
    }

    onNewEvent(event:string) {
        switch (event) {
            case 'project': this.createProjectComponent.toggleDialog();window.location.reload();break;
            case 'client': this.createProjectComponent.toggleDialog();break;
        }
    }


    onNewEmail() {
        this.selectedEmail = new Email();
        this.createEmailComponent.show(this.selectedEmail);
    }

    changeFileName(val: Node) {
       // this.simpleInputComponent.setNode(val);
    }

    onNodeSelected(val: (Node|Leaf)) {
        //  alert(val.getName()+'; Node path: '+ val.getPath());
        if(val instanceof Leaf) {
            // this.selectedEmail = null;

            let found = false;
            for(const mail of this.emailArr) {
                if(mail.templateId === val.getTemplateId()) {
                    this.selectedEmail = mail;
                    found = true;
                }
            }
            this.createEmailComponent.show(this.selectedEmail);
            /*for (const email of this.emailArr) {
                if (email.configPath === val.getPath()) {
                    this.selectedEmail = email;
                    this.createEmailComponent.show();
                    break;
                }
            }*/
            if(!found) {
                this.selectedEmail = new Email();
            }
            this.selectedEmail.configPath = val.getPath();
        }
    }

  evaluate(templateId: String, selectedEmailTemplate) {
    return templateId === selectedEmailTemplate;
  }

  generateAlert(val:string) {
    this.genericModal.defineModal(val,'Mail Preview',250);
    this.genericModal.toggleModal();
  }
}
